import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Table,
  Space,
  Button,
  Tag
} from '@lockerpm/design';

import {
  DeleteOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

import global from "../../../../../config/global";

import {
  convertDateTime,
  wsMemberRole,
  wsMemberStatus
} from '../../../../../secrets-web/src/utils/common'

const TableData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)

  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    rowSelection = {},
    onDelete = () => {}
  } = props;

  const columns = useMemo(() => {
    return [
      {
        title: t('common.no'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 80,
      },
      {
        title: t('common.email'),
        dataIndex: 'email',
        key: 'email',
        align: 'left',
        width: 300,
        render: (_, record) => <TextCopy
          value={record.email || record.user?.email}
        />
      },
      {
        title: t('common.role'),
        dataIndex: 'role',
        key: 'role',
        align: 'center',
        width: 200,
        render: (_, record) => {
          const role = wsMemberRole(record.role)
          return <Tag
            color={role?.color}
          >
            <TextCopy
              value={t(role?.label)}
            />
          </Tag>
        }
      },
      {
        title: t('common.status'),
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: 200,
        render: (_, record) => {
          const status = wsMemberStatus(record.status)
          return <Tag
            color={status?.color}
          >
            <TextCopy
              value={t(status?.label)}
            />
          </Tag>
        }
      },
      {
        title: t('common.access_date'),
        dataIndex: 'access_date',
        key: 'access_date',
        align: 'center',
        width: 200,
        render: (_, record) => <TextCopy
          value={convertDateTime(record.access_date)}
          align={'center'}
        />
      },
      {
        title: t('common.actions'),
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        fixed: 'right',
        width: 100,
        render: (_, record) => (
          <Space size={[8, 8]}>
            {
              global.constants.WS_MEMBER_ROLE.ADMIN !== record.role && <Button
                icon={<DeleteOutlined />}
                type={'link'}
                danger
                onClick={() => onDelete(record)}
              ></Button>
            }
          </Space>
        ),
      },
    ].filter((c) => !c.hide)
  }, [selectedWorkspace])

  return (
    <Table
      className={className}
      columns={columns}
      dataSource={data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))}
      loading={loading}
      pagination={false}
      rowKey={(record) => record?.id}
      size="small"
      // rowSelection={rowSelection}
      sortDirections={['ascend', 'descend']}
      scroll={{ x: 1024 }}
    />
  );
}

export default TableData;
